import type { WebTemplateHref } from '@generalTypes/apiTypes';
import { loadWebConfigurations } from '@newStore/documentApi/documentApiState';
import { selectProNewsItemNode } from '@newStore/documentUI/transformContent/pronewsitemSelectors';
import { loadIncomingReferences } from '@newStore/externalData/externalDataState';
import { NodeType, RequiredType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { newsItemDeleteValidationCmd } from '@store/commands/documentListCommands';
import { webSitesProHref } from '../../../../reduxLoop/api/apiRoutes';
import { accessRights } from '../../../../reduxLoop/helpers/accessRights';
import { settings } from '../../../settings';

const PRONEWSITEM: RootNodeConfig = {
  nodeSelector: selectProNewsItemNode,
  deleteFromListValidations: [newsItemDeleteValidationCmd],
  validationRules: [],
  information: {
    definiteArticle: true,
    single: 'PRO.-nieuwsbericht',
    plural: 'PRO.-nieuwsberichten',
    icon: require('../../../../../img/icons/document.svg'),
    category: 'PRO',
  },
  onLoadActions: [loadWebConfigurations(), loadIncomingReferences()],
  createDefaults: {
    accessRights: accessRights.publiek.namedsets,
    descendantsAccessRights: accessRights.publiek.namedsets,
  },
  websiteHref: webSitesProHref,
  webconfiguration: {
    type: 'NEWS_ITEM_AND_TEASER_FALLBACK',
    website: {
      href: webSitesProHref,
    },
    template: {
      href: '/web/templates/d153f5d5-78b3-4de7-a231-281da633a8bb' as WebTemplateHref,
    },
  },
  createModal: {
    authors: {
      addUser: true,
      required: true,
    },
  },
  buildingBlocks: [
    { type: NodeType.SECTION },
    { type: NodeType.PARAGRAPH },
    { type: NodeType.IMAGE },
    { type: NodeType.IMAGE_GROUP },
    { type: NodeType.ATTACHMENTS_GROUP },
    { type: NodeType.VIDEO },
    { type: NodeType.QUOTE },
    { type: NodeType.SUMMARY },
    { type: NodeType.EXAMPLE },
    { type: NodeType.WORD_IMPORT },
  ],
  tocTypes: [NodeType.SECTION],
  edit: [
    {
      ...titleComponent,
    },
    {
      ...authorsComponent,
      required: RequiredType.ERROR,
    },
    publishComponent,
  ],
  webTab: asideWebBasicConfiguration,
  isCreatable: true,
  isSearchable: true,
  isImportable: true,
  allowSuggestions: true,
  websiteEdition: [
    {
      domain: settings.domains.pro,
    },
  ],
};

export default PRONEWSITEM;
